import { type NativeMessenger } from './native-messenger'
import { type NativeRequestPayload } from './native-request'

export const androidAdapter: NativeMessenger = {
  isAvailable: () => {
    return !!window?.androidListener?.postMessage
  },
  send: (payload: NativeRequestPayload) => {
    const msg = JSON.stringify(payload)
    window?.androidListener?.postMessage(msg)
  }
}
